import React, { useState } from "react";
import { Link } from "react-router-dom";

import user from "../../assets/images/user.png"
import avatar2 from "../../assets/images/avatar-2.png"
import avatar5 from "../../assets/images/avatar-5.png"
import avatar6 from "../../assets/images/avatar-6.png"
import avatar7 from "../../assets/images/avatar-7.png"
import avatar8 from "../../assets/images/avatar-8.png"
import avatar9 from "../../assets/images/avatar-9.png"
import avatar14 from "../../assets/images/avatar-14.png"
import avatar16 from "../../assets/images/avatar-16.png"

const TeamConversation = () => {

  const [isDropdownVisible, setDropdownVisibility] = useState(false);
  const [isDropdownVisible2, setDropdownVisibility2] = useState(false);
  const [isDropdownVisible3, setDropdownVisibility3] = useState(false);
  const [isDropdownVisible4, setDropdownVisibility4] = useState(false);
  const [isDropdownVisible5, setDropdownVisibility5] = useState(false);
  const [isDropdownVisible6, setDropdownVisibility6] = useState(false);

  const toggleDropdown = () => {
    setDropdownVisibility(!isDropdownVisible);
  };
  const toggleDropdown2 = () => {
    setDropdownVisibility2(!isDropdownVisible2);
  };
  const toggleDropdown3 = () => {
    setDropdownVisibility3(!isDropdownVisible3);
  };
  const toggleDropdown4 = () => {
    setDropdownVisibility4(!isDropdownVisible4);
  };
  const toggleDropdown5 = () => {
    setDropdownVisibility5(!isDropdownVisible5);
  };
  const toggleDropdown6 = () => {
    setDropdownVisibility6(!isDropdownVisible6);
  };
  return (
    <React.Fragment>
      <div className="hidden h-full bg-white border rounded xl:col-span-3 dark:bg-darklight dark:border-darkborder border-black/10 xl:block">
        <div className="p-5 border-b dark:border-darkborder border-black/10">
          <h6 className="font-semibold text-black dark:text-white/80">
            Team's Conversation
          </h6>
        </div>
        <div className="p-5">
          <div className="flex items-center mb-3">
            <h6 className="text-black grow dark:text-white/80">Team Chat</h6>
            <Link to="#!" className="underline shrink-0 text-purple">
              See All
            </Link>
          </div>
          <div className="flex flex-col gap-3 h-[440px]  overflow-y-auto">
            <div className="flex gap-2 ltr:mr-10 rtl:ml-10 ltr:[&.right]:mr-0 rtl:[&.right]:ml-0 ltr:[&.right]:ml-10 rtl:[&.right]:mr-10 group">
              <img
                src={avatar14}
                alt=""
                className="group-[&.right]:order-2 rounded-full size-8 shrink-0"
              />
              <div className="group-[&.right]:order-1 p-2 text-sm bg-gray-100 dark:bg-darkborder/50 dark:text-white/80 rounded-md ltr:group-[&.right]:text-right rtl:group-[&.right]:text-left">
                <p>
                  Hello, welcome to the SRBThemes thank you for visiting our
                  website. How can we assist you?
                </p>
              </div>
            </div>
            <div className="flex gap-2 ltr:mr-10 rtl:ml-10 ltr:[&.right]:mr-0 rtl:[&.right]:ml-0 ltr:[&.right]:ml-10 rtl:[&.right]:mr-10 group right">
              <img
                src={user}
                alt=""
                className="group-[&.right]:order-2 rounded-full size-8 shrink-0"
              />
              <div className="group-[&.right]:order-1 p-2 text-sm bg-gray-100 dark:bg-darkborder/50 dark:text-white/80 rounded-md ltr:group-[&.right]:text-right rtl:group-[&.right]:text-left">
                <p>
                  Hello, I would like to mention that this chat may be recorded
                  for the internal training process.
                </p>
              </div>
            </div>
            <div className="flex gap-2 ltr:mr-10 rtl:ml-10 ltr:[&.right]:mr-0 rtl:[&.right]:ml-0 ltr:[&.right]:ml-10 rtl:[&.right]:mr-10 group">
              <img
                src={avatar14}
                alt=""
                className="group-[&.right]:order-2 rounded-full size-8 shrink-0"
              />
              <div className="group-[&.right]:order-1 p-2 text-sm bg-gray-100 dark:bg-darkborder/50 dark:text-white/80 rounded-md ltr:group-[&.right]:text-right rtl:group-[&.right]:text-left">
                <p>May I request you to share your contact details?</p>
              </div>
            </div>
            <div className="flex gap-2 ltr:mr-10 rtl:ml-10 ltr:[&.right]:mr-0 rtl:[&.right]:ml-0 ltr:[&.right]:ml-10 rtl:[&.right]:mr-10 group">
              <img
                src={avatar14}
                alt=""
                className="group-[&.right]:order-2 rounded-full size-8 shrink-0"
              />
              <div className="group-[&.right]:order-1 p-2 text-sm bg-gray-100 dark:bg-darkborder/50 dark:text-white/80 rounded-md ltr:group-[&.right]:text-right rtl:group-[&.right]:text-left">
                <p>
                  I can explain to you the installation steps of Sliced. Shall I
                  go ahead?
                </p>
              </div>
            </div>
            <div className="flex gap-2 ltr:mr-10 rtl:ml-10 ltr:[&.right]:mr-0 rtl:[&.right]:ml-0 ltr:[&.right]:ml-10 rtl:[&.right]:mr-10 group right">
              <img
                src={user}
                alt=""
                className="group-[&.right]:order-2 rounded-full size-8 shrink-0"
              />
              <div className="group-[&.right]:order-1 p-2 text-sm bg-gray-100 dark:bg-darkborder/50 dark:text-white/80 rounded-md ltr:group-[&.right]:text-right rtl:group-[&.right]:text-left">
                <p>
                  What brings you to our website? What are you looking for? It
                  will help us to serve you better.
                </p>
              </div>
            </div>
            <div className="flex gap-2 ltr:mr-10 rtl:ml-10 ltr:[&.right]:mr-0 rtl:[&.right]:ml-0 ltr:[&.right]:ml-10 rtl:[&.right]:mr-10 group right">
              <img
                src={user}
                alt=""
                className="group-[&.right]:order-2 rounded-full size-8 shrink-0"
              />
              <div className="group-[&.right]:order-1 p-2 text-sm bg-gray-100 dark:bg-darkborder/50 dark:text-white/80 rounded-md ltr:group-[&.right]:text-right rtl:group-[&.right]:text-left">
                <p>
                  It will just take a moment to go through the details – Can I
                  put you on hold?
                </p>
              </div>
            </div>
            <div className="flex gap-2 ltr:mr-10 rtl:ml-10 ltr:[&.right]:mr-0 rtl:[&.right]:ml-0 ltr:[&.right]:ml-10 rtl:[&.right]:mr-10 group">
              <img
                src={avatar14}
                alt=""
                className="group-[&.right]:order-2 rounded-full size-8 shrink-0"
              />
              <div className="group-[&.right]:order-1 p-2 text-sm bg-gray-100 dark:bg-darkborder/50 dark:text-white/80 rounded-md ltr:group-[&.right]:text-right rtl:group-[&.right]:text-left">
                <p>
                  I would like to recommend a “solution” that fits your
                  requirements.
                </p>
              </div>
            </div>
          </div>
          <div className="relative mt-5">
            <input
              type="text"
              placeholder="Type your message"
              className="w-full px-4 py-2 bg-white border rounded dark:bg-darklight dark:border-darkborder border-black/10 focus:outline-none focus:shadow-none focus:ring-0"
            />
            <Link
              to="#!"
              className="absolute flex items-center justify-center w-8 h-8 rounded-md ltr:right-1.5 rtl:left-1.5 bg-purple top-[5px] text-white"
            >
              <i className="ri-send-plane-2-line"></i>
            </Link>
          </div>
          <div className="flex items-center mt-5 mb-3">
            <h6 className="text-black grow dark:text-white/80">Team Members</h6>
            <Link to="#!" className="underline shrink-0 text-purple">
              View All
            </Link>
          </div>
          <ul className="flex flex-col gap-3 mb-4">
            <li>
              <div className="flex items-center gap-3">
                <div className="relative rounded-full shrink-0">
                  <img
                    src={avatar2}
                    alt=""
                    className="rounded-full size-9"
                  />
                  <span className="inline-block size-2 bg-success rounded-full absolute ltr:right-0.5 rtl:left-0.5 bottom-[1px] border border-white"></span>
                </div>
                <div className="grow">
                  <h6 className="mb-1 text-black dark:text-white/80">
                    <Link to="#!">Natali Craig</Link>
                  </h6>
                  <p className="text-xs text-muted">Creative Designer</p>
                </div>
                <div x-data="{ dropdown: false}" className="shrink-0 dropdown">
                  <Link to="#" className="text-black dark:text-white" onClick={toggleDropdown}>
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 12.75C9.69036 12.75 10.25 13.3096 10.25 14C10.25 14.6904 9.69036 15.25 9 15.25C8.30964 15.25 7.75 14.6904 7.75 14C7.75 13.3096 8.30964 12.75 9 12.75Z"
                        fill="currentColor"
                      ></path>
                      <path
                        d="M14 12.75C14.6904 12.75 15.25 13.3096 15.25 14C15.25 14.6904 14.6904 15.25 14 15.25C13.3096 15.25 12.75 14.6904 12.75 14C12.75 13.3096 13.3096 12.75 14 12.75Z"
                        fill="currentColor"
                      ></path>
                      <path
                        d="M20.25 14C20.25 13.3096 19.6904 12.75 19 12.75C18.3096 12.75 17.75 13.3096 17.75 14C17.75 14.6904 18.3096 15.25 19 15.25C19.6904 15.25 20.25 14.6904 20.25 14Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </Link>
                  {isDropdownVisible && (
                  <ul
                    x-show="dropdown"
                    className="ltr:right-0 rtl:left-0 whitespace-nowrap"
                  >
                    <li>
                      <Link to="#">Weekly</Link>
                    </li>
                    <li>
                      <Link to="#">Monthly</Link>
                    </li>
                    <li>
                      <Link to="#">Yearly</Link>
                    </li>
                  </ul>
                  )}
                </div>
              </div>
            </li>
            <li>
              <div className="flex items-center gap-3">
                <div className="relative rounded-full shrink-0">
                  <img
                    src={avatar5}
                    alt=""
                    className="rounded-full size-9"
                  />
                  <span className="inline-block size-2 bg-danger rounded-full absolute ltr:right-0.5 rtl:left-0.5 bottom-[1px] border border-white"></span>
                </div>
                <div className="grow">
                  <h6 className="mb-1 text-black dark:text-white/80">
                    <Link to="#!">William Johnson</Link>
                  </h6>
                  <p className="text-xs text-muted">Asp.Net Developer</p>
                </div>
                <div x-data="{ dropdown: false}" className="shrink-0 dropdown">
                  <Link to="#" className="text-black dark:text-white" onClick={toggleDropdown2}>
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 12.75C9.69036 12.75 10.25 13.3096 10.25 14C10.25 14.6904 9.69036 15.25 9 15.25C8.30964 15.25 7.75 14.6904 7.75 14C7.75 13.3096 8.30964 12.75 9 12.75Z"
                        fill="currentColor"
                      ></path>
                      <path
                        d="M14 12.75C14.6904 12.75 15.25 13.3096 15.25 14C15.25 14.6904 14.6904 15.25 14 15.25C13.3096 15.25 12.75 14.6904 12.75 14C12.75 13.3096 13.3096 12.75 14 12.75Z"
                        fill="currentColor"
                      ></path>
                      <path
                        d="M20.25 14C20.25 13.3096 19.6904 12.75 19 12.75C18.3096 12.75 17.75 13.3096 17.75 14C17.75 14.6904 18.3096 15.25 19 15.25C19.6904 15.25 20.25 14.6904 20.25 14Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </Link>
                  {isDropdownVisible2 && (
                  <ul
                    x-show="dropdown"
                    className="ltr:right-0 rtl:left-0 whitespace-nowrap"
                  >
                    <li>
                      <Link to="#">Weekly</Link>
                    </li>
                    <li>
                      <Link to="#">Monthly</Link>
                    </li>
                    <li>
                      <Link to="#">Yearly</Link>
                    </li>
                  </ul>
                  )}
                </div>
              </div>
            </li>
            <li>
              <div className="flex items-center gap-3">
                <div className="relative rounded-full shrink-0">
                  <img
                    src={avatar6}
                    alt=""
                    className="rounded-full size-9"
                  />
                  <span className="inline-block size-2 bg-success rounded-full absolute ltr:right-0.5 rtl:left-0.5 bottom-[1px] border border-white"></span>
                </div>
                <div className="grow">
                  <h6 className="mb-1 text-black dark:text-white/80">
                    <Link to="#!">Michael Brown</Link>
                  </h6>
                  <p className="text-xs text-muted">Laravel Developer</p>
                </div>
                <div x-data="{ dropdown: false}" className="shrink-0 dropdown">
                  <Link to="#" className="text-black dark:text-white" onClick={toggleDropdown3}>
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 12.75C9.69036 12.75 10.25 13.3096 10.25 14C10.25 14.6904 9.69036 15.25 9 15.25C8.30964 15.25 7.75 14.6904 7.75 14C7.75 13.3096 8.30964 12.75 9 12.75Z"
                        fill="currentColor"
                      ></path>
                      <path
                        d="M14 12.75C14.6904 12.75 15.25 13.3096 15.25 14C15.25 14.6904 14.6904 15.25 14 15.25C13.3096 15.25 12.75 14.6904 12.75 14C12.75 13.3096 13.3096 12.75 14 12.75Z"
                        fill="currentColor"
                      ></path>
                      <path
                        d="M20.25 14C20.25 13.3096 19.6904 12.75 19 12.75C18.3096 12.75 17.75 13.3096 17.75 14C17.75 14.6904 18.3096 15.25 19 15.25C19.6904 15.25 20.25 14.6904 20.25 14Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </Link>
                  {isDropdownVisible3 && (
                  <ul
                    x-show="dropdown"
                    className="ltr:right-0 rtl:left-0 whitespace-nowrap"
                  >
                    <li>
                      <Link to="#">Weekly</Link>
                    </li>
                    <li>
                      <Link to="#">Monthly</Link>
                    </li>
                    <li>
                      <Link to="#">Yearly</Link>
                    </li>
                  </ul>
                  )}
                </div>
              </div>
            </li>
            <li>
              <div className="flex items-center gap-3">
                <div className="relative rounded-full shrink-0">
                  <img
                    src={avatar8}
                    alt=""
                    className="rounded-full size-9"
                  />
                  <span className="inline-block size-2 bg-success rounded-full absolute ltr:right-0.5 rtl:left-0.5 bottom-[1px] border border-white"></span>
                </div>
                <div className="grow">
                  <h6 className="mb-1 text-black dark:text-white/80">
                    <Link to="#!">Kate Morrison</Link>
                  </h6>
                  <p className="text-xs text-muted">UI / UX Designer</p>
                </div>
                <div x-data="{ dropdown: false}" className="shrink-0 dropdown">
                  <Link to="#" className="text-black dark:text-white" onClick={toggleDropdown4}>
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 12.75C9.69036 12.75 10.25 13.3096 10.25 14C10.25 14.6904 9.69036 15.25 9 15.25C8.30964 15.25 7.75 14.6904 7.75 14C7.75 13.3096 8.30964 12.75 9 12.75Z"
                        fill="currentColor"
                      ></path>
                      <path
                        d="M14 12.75C14.6904 12.75 15.25 13.3096 15.25 14C15.25 14.6904 14.6904 15.25 14 15.25C13.3096 15.25 12.75 14.6904 12.75 14C12.75 13.3096 13.3096 12.75 14 12.75Z"
                        fill="currentColor"
                      ></path>
                      <path
                        d="M20.25 14C20.25 13.3096 19.6904 12.75 19 12.75C18.3096 12.75 17.75 13.3096 17.75 14C17.75 14.6904 18.3096 15.25 19 15.25C19.6904 15.25 20.25 14.6904 20.25 14Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </Link>
                  {isDropdownVisible4 && (
                  <ul
                    x-show="dropdown"
                    className="ltr:right-0 rtl:left-0 whitespace-nowrap"
                  >
                    <li>
                      <Link to="#">Weekly</Link>
                    </li>
                    <li>
                      <Link to="#">Monthly</Link>
                    </li>
                    <li>
                      <Link to="#">Yearly</Link>
                    </li>
                  </ul>
                  )}
                </div>
              </div>
            </li>
            <li>
              <div className="flex items-center gap-3">
                <div className="relative rounded-full shrink-0">
                  <img
                    src={avatar9}
                    alt=""
                    className="rounded-full size-9"
                  />
                  <span className="inline-block size-2 bg-danger rounded-full absolute ltr:right-0.5 rtl:left-0.5 bottom-[1px] border border-white"></span>
                </div>
                <div className="grow">
                  <h6 className="mb-1 text-black dark:text-white/80">
                    <Link to="#!">Catherine</Link>
                  </h6>
                  <p className="text-xs text-muted">React Developer</p>
                </div>
                <div x-data="{ dropdown: false}" className="shrink-0 dropdown">
                  <Link to="#" className="text-black dark:text-white" onClick={toggleDropdown5}>
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 12.75C9.69036 12.75 10.25 13.3096 10.25 14C10.25 14.6904 9.69036 15.25 9 15.25C8.30964 15.25 7.75 14.6904 7.75 14C7.75 13.3096 8.30964 12.75 9 12.75Z"
                        fill="currentColor"
                      ></path>
                      <path
                        d="M14 12.75C14.6904 12.75 15.25 13.3096 15.25 14C15.25 14.6904 14.6904 15.25 14 15.25C13.3096 15.25 12.75 14.6904 12.75 14C12.75 13.3096 13.3096 12.75 14 12.75Z"
                        fill="currentColor"
                      ></path>
                      <path
                        d="M20.25 14C20.25 13.3096 19.6904 12.75 19 12.75C18.3096 12.75 17.75 13.3096 17.75 14C17.75 14.6904 18.3096 15.25 19 15.25C19.6904 15.25 20.25 14.6904 20.25 14Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </Link>
                  {isDropdownVisible5 && (
                  <ul
                    x-show="dropdown"
                    className="ltr:right-0 rtl:left-0 whitespace-nowrap"
                  >
                    <li>
                      <Link to="#">Weekly</Link>
                    </li>
                    <li>
                      <Link to="#">Monthly</Link>
                    </li>
                    <li>
                      <Link to="#">Yearly</Link>
                    </li>
                  </ul>
                  )}
                </div>
              </div>
            </li>
            <li>
              <div className="flex items-center gap-3">
                <div className="relative rounded-full shrink-0">
                  <div className="relative flex items-center justify-start text-black w-9 h-9">
                    <img
                      className="absolute top-0 left-0 object-cover w-5 h-5 overflow-hidden rounded-full ring-2 ring-white"
                      src={avatar16}
                      alt=""
                    />
                    <img
                      className="absolute top-0 right-0 object-cover w-5 h-5 overflow-hidden rounded-full ring-2 ring-white"
                      src={avatar14}
                      alt=""
                    />
                    <img
                      className="absolute bottom-0 object-cover w-5 h-5 overflow-hidden rounded-full left-1/4 ring-2 ring-white"
                      src={avatar7}
                      alt=""
                    />
                  </div>
                </div>
                <div className="grow">
                  <h6 className="mb-1 text-black dark:text-white/80">
                    <Link to="#!">Jackson, Michael, Lee</Link>
                  </h6>
                  <p className="text-xs text-muted">Developer Team</p>
                </div>
                <div x-data="{ dropdown: false}" className="shrink-0 dropdown">
                  <Link to="#" className="text-black dark:text-white" onClick={toggleDropdown6}>
                    <svg
                      width="28"
                      height="28"
                      viewBox="0 0 28 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 12.75C9.69036 12.75 10.25 13.3096 10.25 14C10.25 14.6904 9.69036 15.25 9 15.25C8.30964 15.25 7.75 14.6904 7.75 14C7.75 13.3096 8.30964 12.75 9 12.75Z"
                        fill="currentColor"
                      ></path>
                      <path
                        d="M14 12.75C14.6904 12.75 15.25 13.3096 15.25 14C15.25 14.6904 14.6904 15.25 14 15.25C13.3096 15.25 12.75 14.6904 12.75 14C12.75 13.3096 13.3096 12.75 14 12.75Z"
                        fill="currentColor"
                      ></path>
                      <path
                        d="M20.25 14C20.25 13.3096 19.6904 12.75 19 12.75C18.3096 12.75 17.75 13.3096 17.75 14C17.75 14.6904 18.3096 15.25 19 15.25C19.6904 15.25 20.25 14.6904 20.25 14Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </Link>
                  {isDropdownVisible6 && (
                  <ul
                    x-show="dropdown"
                    className="ltr:right-0 rtl:left-0 whitespace-nowrap"
                  >
                    <li>
                      <Link to="#">Weekly</Link>
                    </li>
                    <li>
                      <Link to="#">Monthly</Link>
                    </li>
                    <li>
                      <Link to="#">Yearly</Link>
                    </li>
                  </ul>
                  )}
                </div>
              </div>
            </li>
          </ul>
          <Link
            to="/chat"
            className="w-full text-center transition-all duration-300 border rounded-md btn text-purple border-purple hover:bg-purple hover:text-white"
          >
            <i className="align-bottom ltr:mr-1 rtl:ml-1 ri-chat-2-line"></i>{" "}
            View All Chat
          </Link>
        </div>
      </div>
    </React.Fragment>
  );
};

export default TeamConversation;
